"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
require("./ActivityCard.scss");
var defaults = {
    children: null,
    info: '',
};
/**
 * Card to pass elements initiating an activity. eg. Upload, Download, etc.
 * @param Props
 * @component
 */
var ActivityCard = function (_a) {
    var _b = _a === void 0 ? defaults : _a, children = _b.children, info = _b.info;
    return (react_1["default"].createElement("div", { className: "activityCard" },
        react_1["default"].createElement("div", { className: "activityCard-action" }, children),
        react_1["default"].createElement("div", { className: "activityCard-info" }, info)));
};
exports["default"] = ActivityCard;
